// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__22kUa","dragIcon":"Choice_dragIcon__K8e2K","left":"Choice_left__2VdYS","input":"Choice_input__2GD4V"};